module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group",
    class: {
      "form-success--": _vm.search
    }
  }, [(_vm.helptipBody && _vm.focused || _vm.helptipBody && _vm.error) ? _c('ed-input-tooltip', {
    class: {
      "error-message": _vm.error
    },
    attrs: {
      "helptipHeader": _vm.helptipHeader,
      "errorTip": _vm.error,
      "helptipBody": _vm.helptipBody
    }
  }) : _vm._e(), (_vm.fieldLabel) ? _c('label', [_vm._v(_vm._s(_vm.fieldLabel)), (_vm.required) ? _c('span', [_vm._v(" *")]) : _vm._e()]) : _vm._e(), _c('input', _vm._b({
    directives: [{
      name: "focus",
      rawName: "v-focus.lazy",
      value: (_vm.autofocus),
      expression: "autofocus",
      modifiers: {
        "lazy": true
      }
    }],
    ref: "input",
    staticClass: "form-control",
    style: (_vm.symbolWidth),
    attrs: {
      "autofocus": _vm.autofocus,
      "dir": _vm.setDir,
      "required": _vm.required,
      "type": _vm.type
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "focus": _vm.emitFocus,
      "blur": _vm.emitBlur,
      "input": function($event) {
        _vm.updateValue($event.target.value)
      },
      "change": function($event) {
        _vm.$emit("change", $event.target.value)
      }
    }
  }, 'input', _vm.$props, false)), (_vm.showPassword) ? _c('span', {
    staticClass: "toggle-password-icon",
    on: {
      "click": _vm.togglePassword
    }
  }, [(_vm.fieldType === "password") ? _c('i', {
    staticClass: "fal fa-eye"
  }) : _vm._e(), (_vm.fieldType === "text") ? _c('i', {
    staticClass: "fal fa-eye-slash"
  }) : _vm._e()]) : _vm._e(), (_vm.search) ? _c('span', {
    staticClass: "search-icon"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]) : _vm._e(), (_vm.symbol) ? _c('span', {
    staticClass: "dawn-input-number-symbol"
  }, [_vm._v(_vm._s(_vm.symbol))]) : _vm._e(), (_vm.helpText) ? _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v(_vm._s(_vm.helpText))]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a6aa196a","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/core/components/edInput/index.vue
// module id = A208
// module chunks = 13 14